import { Col, Row as AntRow } from 'antd';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { ReactComponent as FormTemplateIconSvg } from 'assets/svgs/form-instance-icon.svg';
import { TaskStatusPicker } from 'components/atoms/tasks';
import { TaskMoreActions } from 'components/molecules/tasks/more-actions';
import { Task } from 'data/tasks';
import { TaskCardTitle } from './title';

export const Row = styled(AntRow).attrs({
  align: 'top',
  justify: 'space-between',
  wrap: false,
})`
  align-items: center;
  .ant-typography {
    margin-bottom: 0;
    margin-top: var(--spacing-02);
  }
`;
const TaskNameWrapper = styled.div`
  display: flex;
  gap: var(--spacing-02);
  align-items: center;
`;
const FormInstanceIconWrapper = styled.div`
  margin-top: 6px;
`;

export const TaskCardHeader = ({ task }: { task: Task }) => {
  const stopEvent = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.stopPropagation();
    },
    [],
  );

  return (
    <Row>
      <Col flex="32px" onClick={stopEvent}>
        <TaskStatusPicker
          taskId={task.taskId}
          projectId={task.project}
          type={task.type}
          progress={task.progress}
          fields={task.fields}
        />
      </Col>
      <Col flex="168px">
        <TaskNameWrapper data-cy={`task-card-name.${task.taskName}`}>
          <FormInstanceIconWrapper>
            {task.formInstanceId ? <FormTemplateIconSvg /> : null}
          </FormInstanceIconWrapper>
          <TaskCardTitle task={task} />
        </TaskNameWrapper>
      </Col>
      <Col flex="32px" id="more-actions" onClick={stopEvent}>
        <TaskMoreActions data={task} />
      </Col>
    </Row>
  );
};
